import { useBotId } from '../../../store/flow'
import { mediaApi } from '../mediaApi'
import { FIXED_CACHE_KEY_FOR_POST } from '../constants'

export const useQueryGetMediaFiles = () => {
  const botId = useBotId()
  return mediaApi.endpoints.getMediaGalleryFiles.useQuery({ botId }, { skip: !botId })
}

export const useMutationUploadMediaFile = () => {
  const botId = useBotId()

  const [nativeTrigger, nativeResult] = mediaApi.endpoints.uploadFileToMediaGallery.useMutation({
    // The fixed cache key is a big of a hack - it works as long as requests are not made in parallel
    // and the cache is not invalidated by other means. It helps us to determine if any files are
    // uploading at any given time, without having to know their filenames. I suppose there should be a
    // cleaner solution, but I don't know it
    fixedCacheKey: FIXED_CACHE_KEY_FOR_POST
  })

  type NativeTriggerParams = Parameters<typeof nativeTrigger>[0]
  type InjectedTriggerParams = Omit<NativeTriggerParams, 'botId'>

  return [
    (param: InjectedTriggerParams) => nativeTrigger({ botId, ...param }),
    nativeResult
  ] as const
}

export const useMutationDeleteMediaFile = () => {
  return mediaApi.endpoints.deleteFileFromMediaGallery.useMutation()
}
